import React, {useState, useEffect} from 'react';
import {isAndroid, isIOS, osName} from 'react-device-detect'
import moment from 'jalali-moment';

import {useHttpClient} from '../../../common/hook/http';

import GlobalConst from '../../../common/global-const';

import OffcanvasOffers from '../../offcanvas/Offers/Offers';

import Loader from '../../../common/component/Loader/Loader';
import NoContent from '../../../common/component/NoContent/NoContent';

import {Container, Row, Col, Tabs, Tab, Button} from 'react-bootstrap';

import {ReactComponent as ImgDirection} from '../../../asset/img/icon/direction.svg';
import {ReactComponent as ImgAddToCalendar} from '../../../asset/img/icon/add-to-calendar.svg';
import * as IconFi from 'react-icons/fi';

import './Offers.scss';

const Offers = () => {
    const {callAPI} = useHttpClient()

    // ------------------------------------------------------------------------------------------------------ fetch data

    const [data, setData] = useState(null)

    useEffect(() => {

        const fetchData = async () => {
            try {
                const responseData = await callAPI(
                    `shop/offers`
                );

                // console.log(responseData)

                if (responseData.message) {

                } else {

                    setData(responseData.result)

                }

            } catch (e) {
                console.error(e);
            }
        }

        fetchData()

    }, []);

    // ------------------------------------------------------------------------------------------------ offers offcanvas

    const [offcanvasOffersShow, setOffcanvasOffersShow] = useState(false);
    const [offcanvasData, setOffcanvasData] = useState(null);

    const offcanvasOffersShowHandler = item => {

        setOffcanvasData(() => {
            return item
        })

        setOffcanvasOffersShow(true);

    }

    // -----------------------------------------------------------------------------------------------------------------

    const renderHref = item => {

        if (osName === 'Android') {

            return `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${item.offer}&dates=${moment.from(item.start_at, 'fa').format('YYYYMMDD')}/${moment.from(item.end_at, 'fa').format('YYYYMMDD')}&location=Kish Island, Iran`;

        } else if(osName === 'iOS') {

            return `data:text/calendar;charset=utf8,BEGIN:VCALENDAR
VERSION:2.0
BEGIN:VEVENT
DTSTART:${moment.from(item.start_at, 'fa').format('YYYYMMDD')}
DTEND:${moment.from(item.end_at, 'fa').format('YYYYMMDD')}
SUMMARY:${item.offer}
LOCATION:Kish Island, Iran
END:VEVENT
END:VCALENDAR`

        } else {
            return '#'
        }

    }

    const renderItem = item => {

        return (
            <Col sm={6} lg={4} key={item.id}>
                <div className="text-reset text-decoration-none d-flex flex-column">
                    <figure className="bg-black bg-opacity-4 ratio ratio-16x9 filter-warm" onClick={() => offcanvasOffersShowHandler(item)}>
                        <span className="filter-level"/>
                        <img src={`${GlobalConst.cdn}${item.photos[0].path}`} className="w-100 h-00 object-fit-cover"/>
                    </figure>
                    <Row className="pb-3 gx-2 action">
                        <Col className="text-end">
                            <Button href={`tel:+98${item.phones[0]}`} variant="link" className="flex-column align-items-center text-center p-0 text-reset text-decoration-none" disabled={!item.phones.length}>
                                <span className="bg-primary bg-opacity-38 p-1 mb-2 rounded-square">
                                    <IconFi.FiPhone size={24} className="sw-1 flip-h"/>
                                </span>
                                <span className="fw-normal lh-sm fs-9">تماس</span>
                            </Button>
                        </Col>
                        <Col className="d-flex justify-content-center">
                            <Button href={`#`} variant="link" className="flex-column align-items-center text-center p-0 text-reset text-decoration-none">
                                <span className="bg-primary bg-opacity-38 p-1 mb-2 rounded-square">
                                    <ImgDirection className="sw-1"/>
                                </span>
                                <span className="fw-normal lh-sm fs-9">راهنمایی مسیر</span>
                            </Button>
                        </Col>
                        <Col>
                            <Button href={renderHref(item)} target="_blank" variant="link" className="flex-column align-items-center text-center p-0 text-reset text-decoration-none" disabled={!(isAndroid || isIOS)}>
                                <span className="bg-primary bg-opacity-38 p-1 mb-2 rounded-square">
                                    <ImgAddToCalendar className="sw-1"/>
                                </span>
                                <span className="fw-normal lh-sm fs-9">افزودن به تقویم</span>
                            </Button>
                        </Col>
                    </Row>
                    <div onClick={() => offcanvasOffersShowHandler(item)}>
                        <div className="fw-500 ls-half ws-n1 fs-5">{item.shopName}</div>
                        <div className="mb-1 fs-18px">{item.offer}</div>
                        <div className="text-white text-opacity-60 ls-1 lh-1 pt-2">{item.start_at}<span className="ls-normal fs-7 px-1"> تا </span>{item.end_at}</div>
                    </div>
                </div>
            </Col>
        )

    }

    // -----------------------------------------------------------------------------------------------------------------

    return (
        <div id="pageOffers" className="mb-4 mb-xl-5">
            <Container fluid="lg" as="section">
                <Row>
                    {
                        data ? (
                            <Col xs={12} className="mb-4 mb-xl-5">
                                <Tabs justify className="hide-scrollbar">
                                    <Tab eventKey="0" title="همه" tabClassName="justify-content-center">
                                        <Row className={`gx-3 gy-5${data.offers.length ? '' : ' mt-0'}`}>
                                            {
                                                data.offers.length ? (
                                                    data.offers.map(item => {
                                                        return (
                                                            renderItem(item)
                                                        )
                                                    })
                                                ) : (
                                                    <div className="py-5 my-5">
                                                        <NoContent text={`تخفیفی وجود ندارد`}/>
                                                    </div>
                                                )
                                            }
                                        </Row>
                                    </Tab>
                                    {
                                        Object.keys(data.shopTypes).map(item => {
                                            return (
                                                <Tab eventKey={item} title={data.shopTypes[item]} tabClassName="justify-content-center" key={item}>
                                                    <Row className={`gx-3 gy-5${data.offers.filter(({shopType}) => shopType === Number(item)).length ? '' : ' mt-0'}`}>
                                                        {
                                                            data.offers.filter(({shopType}) => shopType === Number(item)).length ? (
                                                                data.offers.filter(({shopType}) => shopType === Number(item)).map(item2 => {
                                                                    return (
                                                                        renderItem(item2)
                                                                    )
                                                                })
                                                            ) : (
                                                                <div className="py-5 my-5">
                                                                    <NoContent text={`در این دسته بندی تخفیفی وجود ندارد`}/>
                                                                </div>
                                                            )
                                                        }
                                                    </Row>
                                                </Tab>
                                            )
                                        })
                                    }
                                </Tabs>
                                <OffcanvasOffers show={offcanvasOffersShow} onHide={() => setOffcanvasOffersShow(false)} data={offcanvasData}/>
                            </Col>
                        ) : (
                            <Col xs={12}>
                                <div className="py-5 my-5">
                                    <Loader text="در حال دریافت اطلاعات"/>
                                </div>
                            </Col>
                        )
                    }
                </Row>
            </Container>
        </div>
    )
}

export default Offers;